import { render } from "./Publish.vue?vue&type=template&id=ba54a47e&scoped=true"
import script from "./Publish.vue?vue&type=script&lang=js"
export * from "./Publish.vue?vue&type=script&lang=js"

import "./Publish.vue?vue&type=style&index=0&id=ba54a47e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba54a47e"]])

export default __exports__